import { useTranslations } from "@/lib/static-intl";
import PlacesMapsDistanceFilterTabs from "@/components/places-comps/map-controls/places-maps-distance-filter-tabs";
import Iconify from "@/components/ui/Iconify";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";

const PlacesMobileTopControllers = ({
  mapMarkers,
  setListPageNo,
  searchAreaAgain,
  infiniteScrollLoader,
  addQueryParam,
  totalPlacesAvailable,
}) => {
  const t = useTranslations("places.place_map");

  const searchParams = useSearchParams();
  const _rad = searchParams.get("radius");
  const showDistanceTabs = searchParams.get("show-around-me") === "yes";

  const [radius, setRadius] = useState(1000);

  const handleRadiusChange = (_r) => {
    if (_r && !isNaN(Number(_r))) {
      setRadius(Number(_r));
      addQueryParam("radius", Number(_r));
    }
  };

  useEffect(() => {
    if (_rad && !isNaN(Number(_rad))) setRadius(_rad);
  }, [_rad]);

  return (
    <div className="flex flex-col gap-2">
      {showDistanceTabs && (
        <PlacesMapsDistanceFilterTabs
          mapRadius={radius}
          handleRadiusChange={handleRadiusChange}
        />
      )}
      {/* "이 지역 다시 검색" button removed: the map now auto-refreshes results on
          pan / zoom-out (onUserMoveEnd in the map component), so a manual re-search
          trigger is redundant. A subtle "updating" state during the auto-fetch is
          handled by the pins refreshing. */}
      <div className="w-full flex justify-between items-center gap-2">
        {mapMarkers?.length < 100 &&
          mapMarkers?.length < totalPlacesAvailable && (
            <button
              type="button"
              onClick={() => {
                setListPageNo((prev) => prev + 1);
              }}
              disabled={infiniteScrollLoader}
              className={`text-xs text-nowrap rounded-2xl bg-[#262626] text-white py-2 px-3 flex items-center justify-center gap-1 transition tracking-tight shadow-md ${
                infiniteScrollLoader && "cursor-not-allowed opacity-70"
              }`}
            >
              <Iconify
                icon={"lineicons:reload"}
                className={`!text-inherit !min-w-3 !h-3 ${
                  infiniteScrollLoader && "animate-spin"
                }`}
              />
              {t("see more places")}
            </button>
          )}
      </div>
    </div>
  );
};

export default PlacesMobileTopControllers;
